<template>
  <form
    @submit.prevent="validateForm"
    :action="banorteValidatorPath"
    ref="form"
    method="POST"
  >
    <input type="hidden" :value="cardNumber" name="CARD_NUMBER">
    <input type="hidden" :value="cardExpirationDate" name="CARD_EXP">
    <input type="hidden" :value="saleOrderTotal" name="AMOUNT">
    <input type="hidden" :value="cardBrand" name="CARD_TYPE">
    <input type="hidden" :value="forwardPath" name="FORWARD_PATH">
    <input type="hidden" :value="saleOrderReference3D" name="REFERENCE3D">
    <input type="hidden" :value="creditType" name="CREDIT_TYPE">
    <input type="hidden" :value="cardHolderEmail" name="EMAIL">
    <input type="hidden" :value="cardHolderCity" name="CITY">
    <input type="hidden" :value="cardHolderFirstName" name="NAME">
    <input type="hidden" :value="cardHolderLastName" name="LAST_NAME">
    <input type="hidden" :value="cardHolderZipCode" name="POSTAL_CODE">
    <input type="hidden" :value="cardHolderState" name="STATE">
    <input type="hidden" :value="cardHolderCountry" name="COUNTRY">
    <input type="hidden" :value="cardHolderStreet" name="STREET">
    <input type="hidden" :value="cardHolderPhone" name="MOBILE_PHONE">
    <input type="hidden" value="8489112" name="MERCHANT_ID">
    <input type="hidden" value="PUENTE ZARAGOZA" name="MERCHANT_NAME">
    <input type="hidden" value="Juarez" name="MERCHANT_CITY">
    <input type="hidden" value="03" name="3D_CERTIFICATION">
    <input type="hidden" value="2" name="THREED_VERSION">
    <div class="form-group flex">
      <p>Estimado usuario, el Fideicomiso de Puentes Fronterizos de Chihuahua no almacena la información solicitada en este formulario, nuestro Banco utiliza estos datos para validar y asegurar su transacción.</p>
    </div>
    <div class="form-group flex justify-space-between">
      <label>Paquetes</label>
      <select v-model="selectedProductId" class="big-input">
        <option value="" disabled>Seleccione una opción</option>
        <option
          v-for="product in annualityProducts"
          v-bind:key="product.id"
          v-bind:value="product.id"
        >
          {{ `${product.name} (${product.formatted_price})` }}
        </option>
      </select>
    </div>
    <div class="errors" v-if="errors.selectedProductId">
      {{ errors.selectedProductId.join(' - ') }}
    </div>
    <div class="form-group flex justify-space-between">
      <label>Tipo de Tarjeta</label>
      <div class="form-group flex justify-flex-end">
        <input
          type="radio"
          :value="0"
          name="debit"
          v-model="cardType"
        />
        <label for="debit">Débito</label>
        <input
          type="radio"
          :value="1"
          name="credit"
          v-model="cardType"
        />
        <label for="credit">Crédito</label>
      </div>
    </div>
    <div class="form-group flex justify-space-between">
      <label for="number">Número de tarjeta</label>
      <input class="big-input" v-model="cardNumber" type="text" maxlength="16">
    </div>
    <div class="errors" v-if="errors.cardNumber">
      {{ errors.cardNumber.join(' - ') }}
    </div>
    <div class="form-group flex justify-space-between">
      <label for="cardHolderFirstName">Nombre</label>
      <input class="big-input" v-model="cardHolderFirstName" type="text" maxlength="60" autocomplete="cc-given-name" placeholder="Nombre">
    </div>
    <div class="errors" v-if="errors.cardHolderFirstName">
      {{ errors.cardHolderFirstName.join(' - ') }}
    </div>
    <div class="form-group flex justify-space-between">
      <label for="cardHolderLastName">Apellidos</label>
      <input class="big-input" v-model="cardHolderLastName" type="text" maxlength="60" autocomplete="cc-family-name" placeholder="Apellidos">
    </div>
    <div class="errors" v-if="errors.cardHolderLastName">
      {{ errors.cardHolderLastName.join(' - ') }}
    </div>
    <div class="form-group flex justify-space-between">
      <label for="cardHolderEmail">Correo electrónico</label>
      <input class="big-input" v-model="cardHolderEmail" type="text" maxlength="255" autocomplete="cc-email" placeholder="Correo electrónico">
    </div>
    <div class="errors" v-if="errors.cardHolderEmail">
      {{ errors.cardHolderEmail.join(' - ') }}
    </div>
    <div class="form-group flex justify-space-between">
      <label for="cardHolderPhone">Número de celular</label>
      <input class="big-input" v-model="cardHolderPhone" type="text" maxlength="25" autocomplete="tel" placeholder="Número celular">
    </div>
    <div class="errors" v-if="errors.cardHolderPhone">
      {{ errors.cardHolderPhone.join(' - ') }}
    </div>
    <div class="form-group flex justify-space-between">
      <label for="cardHolderStreet">Calle</label>
      <input class="big-input" v-model="cardHolderStreet" type="text" maxlength="60" autocomplete="street-address" placeholder="Calle">
    </div>
    <div class="errors" v-if="errors.cardHolderStreet">
      {{ errors.cardHolderStreet.join(' - ') }}
    </div>
    <div class="form-group flex justify-space-between">
      <label for="cardHolderCity">Ciudad</label>
      <input class="big-input" v-model="cardHolderCity" type="text" maxlength="50" autocomplete="city" placeholder="Ciudad">
    </div>
    <div class="errors" v-if="errors.cardHolderCity">
      {{ errors.cardHolderCity.join(' - ') }}
    </div>
    <div class="form-group flex justify-space-between">
      <label for="cardHolderZipCode">Código postal</label>
      <input class="big-input" v-model="cardHolderZipCode" type="text" maxlength="10" autocomplete="zipcode" placeholder="Código postal">
    </div>
    <div class="errors" v-if="errors.cardHolderZipCode">
      {{ errors.cardHolderZipCode.join(' - ') }}
    </div>
    <div class="form-group flex justify-space-between">
      <label>País</label>
      <select v-model="cardHolderCountry" class="big-input">
        <option value="" disabled>Seleccione el país</option>
        <option
          v-for="country in [{id: 'MX', name: 'México'}, {id: 'US', name: 'United States'}]"
          :key="country.id"
          :value="country.id"
        >
          {{ country.name }}
        </option>
      </select>
    </div>
    <div class="errors" v-if="errors.cardHolderCountry">
      {{ errors.cardHolderCountry.join(' - ') }}
    </div>
    <div class="form-group flex justify-space-between">
      <label>Estado</label>
      <select v-model="cardHolderState" class="big-input">
        <option value="" disabled>Seleccione el estado</option>
        <option
          v-for="state in statesList"
          :key="state.id"
          :value="state.id"
        >
          {{ state.value }}
        </option>
      </select>
    </div>
    <div class="errors" v-if="errors.cardHolderState">
      {{ errors.cardHolderState.join(' - ') }}
    </div>
    <div class="form-group flex justify-space-between">
      <label for="exp">Fecha de expiración</label>
      <div>
        <select
          v-model="cardExpirationMonth"
          class="short-input"
        >
          <option value="" selected disabled>MM</option>
          <option
            v-for="month in availableCardExpirationMonths"
            :key="month"
          >
            {{ month }}
          </option>
        </select>
        <span>/</span>
        <select
          v-model="cardExpirationYear"
          class="short-input"
        >
          <option value="" selected disabled>AA</option>
          <option
            v-for="year in availableCardExpirationYears"
            :key="year"
          >
            {{ year }}
          </option>
        </select>
      </div>
    </div>
    <div class="errors" v-if="errors.cardExpirationDate">
      {{ errors.cardExpirationDate.join(' - ') }}
    </div>
    <div class="flex justify-space-between">
      <p>Nueva fecha de expiración</p>
      <p>{{ selectedVehicleNewExpirationDate }}</p>
    </div>
    <div v-if="selectedProductFormattedPrice" class="flex justify-space-between">
      <p>Precio</p>
      <p>{{ selectedProductFormattedPrice }}</p>
    </div>
    <div v-if="formattedCommissionPrice" class="flex justify-space-between">
      <p>Comisión</p>
      <p>{{ formattedCommissionPrice }}</p>
    </div>
    <div v-if="formattedTotal" class="flex justify-space-between">
      <p>Total</p>
      <p>{{ formattedTotal }}</p>
    </div>
    <InformationModal @confirm="closeInformationModal" title="Atención" :active="isInformationModalActive">
      <template slot="content">
        <p>
          A continuación te enviaremos al sitio web de Banorte en donde validaremos tu tarjeta utilizando los datos que acabas
          de introducir, recuerda que debes conocer el método de validación usado por tu banco (SMS, correo electrónico, App Móvil).
          Una vez que validemos tu tarjeta, volverás automáticamente a este sitio para finalmente completar tu compra. Si tienes
          dudas sobre el proceso de validación <strong>3D Secure</strong>, contacta a tu banco.
        </p>
      </template>
    </InformationModal>
    <div class="flex justify-space-evenly-sm">
      <button type="submit" class="btn" :disabled="dataReady == false">Aceptar</button>
    </div>
  </form>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import InformationModal from '@/components/InformationModal'

export default {
  name: 'AnnualityForm',
  components: {
    InformationModal
  },
  data () {
    return {
      isInformationModalActive: false,
      errors: {}
    }
  },
  computed: {
    ...mapState('user', {
      user: (user) => user
    }),
    ...mapGetters('app', ['isLoading']),
    ...mapGetters('createdSaleOrder', [
      'saleOrderId',
      'saleOrderReference3D',
      'saleOrderTotal'
    ]),
    ...mapGetters('products', [
      'annualityProducts',
      'selectedProductFormattedPrice'
    ]),
    ...mapGetters('saleOrderForm', [
      'cardBrand',
      'cardExpirationDate',
      'formattedCommissionPrice',
      'formattedTotal',
      'selectedVehicleNewExpirationDate',
      'creditType',
      'cardHolderName'
    ]),
    cardExpirationMonth: {
      get () { return this.$store.state.saleOrderForm.cardExpirationMonth },
      set (value) { this.updateCardExpirationMonth(value) }
    },
    cardExpirationYear: {
      get () { return this.$store.state.saleOrderForm.cardExpirationYear },
      set (value) { this.updateCardExpirationYear(value) }
    },
    cardHolderFirstName: {
      get () { return this.$store.state.saleOrderForm.cardHolderFirstName },
      set (value) { this.updateCardHolderFirstName(value) }
    },
    cardHolderLastName: {
      get () { return this.$store.state.saleOrderForm.cardHolderLastName },
      set (value) { this.updateCardHolderLastName(value) }
    },
    cardHolderEmail: {
      get () { return this.$store.state.saleOrderForm.cardHolderEmail },
      set (value) { this.updateCardHolderEmail(value) }
    },
    cardHolderStreet: {
      get () { return this.$store.state.saleOrderForm.cardHolderStreet },
      set (value) { this.updateCardHolderStreet(value) }
    },
    cardHolderCity: {
      get () { return this.$store.state.saleOrderForm.cardHolderCity },
      set (value) { this.updateCardHolderCity(value) }
    },
    cardHolderPhone: {
      get () { return this.$store.state.saleOrderForm.cardHolderPhone },
      set (value) { this.updateCardHolderPhone(value) }
    },
    cardHolderZipCode: {
      get () { return this.$store.state.saleOrderForm.cardHolderZipCode },
      set (value) { this.updateCardHolderZipCode(value) }
    },
    cardHolderState: {
      get () { return this.$store.state.saleOrderForm.cardHolderState },
      set (value) { this.updateCardHolderState(value) }
    },
    cardHolderCountry: {
      get () { return this.$store.state.saleOrderForm.cardHolderCountry },
      set (value) { this.updateCardHolderCountry(value) }
    },
    cardNumber: {
      get () { return this.$store.state.saleOrderForm.cardNumber },
      set (value) { this.updateCardNumber(value) }
    },
    cardType: {
      get () { return this.$store.state.saleOrderForm.cardType },
      set (value) { this.updateCardType(value) }
    },
    selectedProductId: {
      get () { return this.$store.state.products.selectedProductId },
      set (value) { this.selectProduct(value) }
    },
    availableCardExpirationMonths () {
      const months = []

      for (let i = 1; i <= 12; i++) {
        const month = i.toLocaleString('en-US', { minimumIntegerDigits: 2 })

        months.push(month)
      }

      return months
    },
    availableCardExpirationYears () {
      const currentYear = new Date().getFullYear()
      const years = []

      for (let i = 0; i <= 10; i++) {
        years.push(currentYear + i)
      }

      return years
    },
    statesList () {
      return {
        MX: [
          { value: 'Aguascalientes', id: 'AG' },
          { value: 'Baja California', id: 'BC' },
          { value: 'Baja California Sur', id: 'BS' },
          { value: 'Campeche', id: 'CM' },
          { value: 'Chiapas', id: 'CS' },
          { value: 'Chihuahua', id: 'CH' },
          { value: 'Ciudad De México', id: 'CX' },
          { value: 'Coahuila', id: 'CO' },
          { value: 'Colima', id: 'CL' },
          { value: 'Durango', id: 'DG' },
          { value: 'Guanajuato', id: 'GT' },
          { value: 'Guerrero', id: 'GR' },
          { value: 'Hidalgo', id: 'HG' },
          { value: 'Jalisco', id: 'JC' },
          { value: 'Estado De México', id: 'EM' },
          { value: 'Michoacán', id: 'MI' },
          { value: 'Morelos', id: 'MO' },
          { value: 'Nayarit', id: 'NA' },
          { value: 'Nuevo León', id: 'NL' },
          { value: 'Oaxaca', id: 'OA' },
          { value: 'Puebla', id: 'PU' },
          { value: 'Querétaro', id: 'QT' },
          { value: 'Quintana Roo', id: 'QR' },
          { value: 'San Luis Potosí', id: 'SL' },
          { value: 'Sinaloa', id: 'SI' },
          { value: 'Sonora', id: 'SO' },
          { value: 'Tabasco', id: 'TB' },
          { value: 'Tamaulipas', id: 'TM' },
          { value: 'Tlaxcala', id: 'TL' },
          { value: 'Veracruz', id: 'VE' },
          { value: 'Yucatán', id: 'YU' },
          { value: 'Zacatecas', id: 'ZA' }
        ],
        US: [
          { value: 'Alabama', id: 'AL' },
          { value: 'Alaska', id: 'AK' },
          { value: 'Arizona', id: 'AZ' },
          { value: 'Arkansas', id: 'AR' },
          { value: 'California', id: 'CA' },
          { value: 'Colorado', id: 'CO' },
          { value: 'Connecticut', id: 'CT' },
          { value: 'Delaware', id: 'DE' },
          { value: 'Florida', id: 'FL' },
          { value: 'Georgia', id: 'GA' },
          { value: 'Hawaii', id: 'HI' },
          { value: 'Idaho', id: 'ID' },
          { value: 'Illinois', id: 'IL' },
          { value: 'Indiana', id: 'IN' },
          { value: 'Iowa', id: 'IA' },
          { value: 'Kansas', id: 'KS' },
          { value: 'Kentucky', id: 'KY' },
          { value: 'Louisiana', id: 'LA' },
          { value: 'Maine', id: 'ME' },
          { value: 'Maryland', id: 'MD' },
          { value: 'Massachusetts', id: 'MA' },
          { value: 'Michigan', id: 'MI' },
          { value: 'Minnesota', id: 'MN' },
          { value: 'Mississippi', id: 'MS' },
          { value: 'Missouri', id: 'MO' },
          { value: 'Montana', id: 'MT' },
          { value: 'Nebraska', id: 'NE' },
          { value: 'Nevada', id: 'NV' },
          { value: 'New Hampshire', id: 'NH' },
          { value: 'New Jersey', id: 'NJ' },
          { value: 'New Mexico', id: 'NM' },
          { value: 'New York', id: 'NY' },
          { value: 'North Carolina', id: 'NC' },
          { value: 'North Dakota', id: 'ND' },
          { value: 'Ohio', id: 'OH' },
          { value: 'Oklahoma', id: 'OK' },
          { value: 'Oregon', id: 'OR' },
          { value: 'Pennsylvania', id: 'PA' },
          { value: 'Rhode Island', id: 'RI' },
          { value: 'South Carolina', id: 'SC' },
          { value: 'South Dakota', id: 'SD' },
          { value: 'Tennessee', id: 'TN' },
          { value: 'Texas', id: 'TX' },
          { value: 'Utah', id: 'UT' },
          { value: 'Vermont', id: 'VT' },
          { value: 'Virginia', id: 'VA' },
          { value: 'Washington', id: 'WA' },
          { value: 'West Virginia', id: 'WV' },
          { value: 'Wisconsin', id: 'WI' },
          { value: 'Wyoming', id: 'WY' }
        ]
      }[this.cardHolderCountry]
    },
    banorteValidatorPath: function () {
      return process.env.VUE_APP_BANORTE_3DSECURE2_URL
    },
    // TODO: Dont use state for form button disable
    dataReady: function () {
      return !this.isLoading
    },
    forwardPath: function () {
      return process.env.VUE_APP_BANORTE_FORWARDPATH
    },
    canProcess: function () {
      return true
    }
  },
  watch: {
    cardNumber (newValue, oldValue) {
      if (newValue.length >= 14) {
        return this.getCommission()
      }

      if (oldValue.length >= 14 && newValue.length < 14) {
        return this.resetCommission()
      }
    }
  },
  methods: {
    ...mapActions('app', [
      'startLoading',
      'finishLoading'
    ]),
    ...mapActions('createdSaleOrder', [
      'createSaleOrder'
    ]),
    ...mapActions('saleOrderForm', [
      'getCommission',
      'resetCommission',
      'updateCardExpirationMonth',
      'updateCardExpirationYear',
      'updateCardHolderFirstName',
      'updateCardHolderLastName',
      'updateCardHolderEmail',
      'updateCardHolderPhone',
      'updateCardHolderStreet',
      'updateCardHolderZipCode',
      'updateCardHolderCountry',
      'updateCardHolderState',
      'updateCardHolderCity',
      'updateCardNumber',
      'updateCardType',
      'updateNewBalance'
    ]),
    ...mapActions('products', ['selectProduct']),
    clearErrors () {
      this.errors = {}
    },
    openInformationModal () {
      this.isInformationModalActive = true
    },
    closeInformationModal () {
      this.submitForm()
    },
    async submitForm () {
      await this.createSaleOrder()

      if (this.saleOrderTotal && this.saleOrderId) {
        this.$refs.form.submit()
      }
    },
    validateForm () {
      const today = new Date()
      const currentYear = today.getFullYear()
      const currentMonth = today.getMonth() + 1

      this.clearErrors()

      if (!this.selectedProductId) {
        this.errors = {
          ...this.errors,
          selectedProductId: [
            'Debes seleccionar un producto'
          ]
        }
      }
      if (!this.cardNumber || this.cardNumber.length < 16) {
        this.errors = {
          ...this.errors,
          cardNumber: [
            'Debes introducir un número de tarjeta válido'
          ]
        }
      }
      if (!this.cardHolderFirstName) {
        this.errors = {
          ...this.errors,
          cardHolderFirstName: [
            'Debes introducir el nombre de la tarjeta'
          ]
        }
      }
      if (!this.cardHolderLastName) {
        this.errors = {
          ...this.errors,
          cardHolderLastName: [
            'Debes introducir los apellidos de la tarjeta'
          ]
        }
      }
      if (!this.cardExpirationMonth || !this.cardExpirationYear || (parseInt(this.cardExpirationYear) === currentYear && parseInt(this.cardExpirationMonth) <= currentMonth)) {
        this.errors = {
          ...this.errors,
          cardExpirationDate: [
            'Debes introducir una fecha de expiración válida para la tarjeta'
          ]
        }
      }
      if (!this.cardHolderState) {
        this.errors = {
          ...this.errors,
          cardHolderState: [
            'Debes seleccionar un Estado'
          ]
        }
      }
      if (!this.cardHolderEmail) {
        this.errors = {
          ...this.errors,
          cardHolderEmail: [
            'Debes introducir un correo electronico'
          ]
        }
      }
      if (!this.cardHolderPhone) {
        this.errors = {
          ...this.errors,
          cardHolderPhone: [
            'Debes introducir un número de teléfono'
          ]
        }
      }
      if (!this.cardHolderStreet) {
        this.errors = {
          ...this.errors,
          cardHolderStreet: [
            'Debes introducir tu calle'
          ]
        }
      }
      if (!this.cardHolderCity) {
        this.errors = {
          ...this.errors,
          cardHolderCity: [
            'Debes introducir tu ciudad'
          ]
        }
      }
      if (!this.cardHolderZipCode) {
        this.errors = {
          ...this.errors,
          cardHolderZipCode: [
            'Debes introducir tu código postal'
          ]
        }
      }
      if (!this.cardHolderCountry) {
        this.errors = {
          ...this.errors,
          cardHolderCountry: [
            'Debes introducir tu país'
          ]
        }
      }
      if (!this.cardHolderState) {
        this.errors = {
          ...this.errors,
          cardHolderState: [
            'Debes introducir tu estado'
          ]
        }
      }
      if (Object.keys(this.errors).length === 0) { // no errors but ...
        this.openInformationModal()
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/constants.scss';

.form-group {
  margin: 0.5rem 0;
}

.errors {
  color: $red;
  font-size: 0.75rem;
  margin-top: -0.5rem;
  margin-bottom: 1rem;
}

.btn {
  font-size: 0.8rem;
  background-color: $light-blue;
  border-radius: 20px;
  color: white;
  border: 0;
  padding: 0.6rem 1.5rem;
  margin: 12px 0;
  cursor: pointer;

  &:focus {
    outline-width: 0;
  }
}

.short-input {
  width: 4rem;
  &:nth-child(1) {
    margin-right: 0.5rem;;
  }
  &:nth-child(3) {
    margin-left: 0.5rem;
  }
}
fieldset {
  display: none;
}
.big-input {
  min-width: 45%;
  max-width: 60%;
}
</style>
